/** Set to true to show the retailer filter on search results. */
export const SEARCH_RETAILER_FILTER_ENABLED = false;
